// firebase
import { doc, getDoc } from "firebase/firestore";
import { db } from "config/firebase";

// A ---------------------------------------------------------------------- M

const getPubKeyUrl = async (uuid) => {
  try {
    const userRef = doc(db, "usercontacts", uuid);
    const userDoc = await getDoc(userRef);
    return userDoc.exists() ? userDoc.data().pubkeyurl ?? "" : "";
  } catch (error) {
    console.error("Error in getPubKeyUrl:", error);
    return "";
  }
};

export default getPubKeyUrl;
